import React, { useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import DriverService from "src/service/driver";
import swal from "sweetalert";
// import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { IconArrowBack } from "@tabler/icons";
import PreviewImage from "src/components/previewImage/PreviewImage";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Driver",
  },
];

const validationSchema = yup.object({
  driver_name: yup
    .string("Enter Driver Name")
    .matches(/^[a-zA-Z ]+$/, "Driver Name should only contain Alphabet")
    .min(2, "Driver Name should be of minimum 2 characters in length")
    .max(30, "Driver Name should be of maximum 30 characters in length")
    .required("Driver Name is required"),

  driver_contact: yup
    .string("Enter your Contact No")
    .matches(/^[0-9]+$/, "Contact No should only contain digits")
    .min(10, "Contact number should be at least 10 digits long")
    .max(10, "Contact number should not exceed 10 digits")
    .required("Contact no is Required"),

  dl_no: yup
    .string("Enter Driving license No")
    .matches(
      /^[A-Z0-9]+$/,
      "Driving license No should be Uppercase and contain Alphabet and Number Only"
    )
    .min(8, "Driving license No should be of minimum 8 characters in length")
    .max(30, "Driving license No should be of maximum 30 characters in length")
    .required("Driving license No is required"),

  aadhar_no: yup
    .string("Enter your Aadhar No")
    .matches(/^[0-9]+$/, "Aadhar No should only contain digits")
    .min(12, "Aadhar No should be at least 12 digits long")
    .max(12, "Aadhar No should not exceed 12 digits")
    .required("Aadhar no is Required"),

  date_of_birth: yup
    .string("Enter Date of birth")
    .required("Date of birth is Required"),

  // age: yup
  //   .string("Enter your Age")
  //   .matches(/^[0-9]+$/, "Age should only contain digits")
  //   .test({
  //     name: "age",
  //     message: "Age should be between 18 and 80",
  //     test: (value) => {
  //       const age = parseInt(value, 10);
  //       return !isNaN(age) && age >= 18 && age <= 80;
  //     },
  //   })
  //   .required("Age is Required"),

  pan_no: yup
    .string("Enter Pan No")
    .matches(
      /^[A-Z0-9]+$/,
      "Pan No should be Uppercase and contain Alphabet and Number Only"
    )
    .min(10, "Pan No should be of minimum 10 characters in length")
    .max(10, "Pan No should be of maximum 10 characters in length")
    .required("Pan No is required"),

  pin_code: yup
    .string("Enter your Pincode")
    .matches(/^[0-9]+$/, "Pincode should only contain digits")
    .min(6, "Pincode should be at least 6 digits long")
    .max(6, "Pincode should not exceed 6 digits")
    .required("Pincode is Required"),

  driver_address: yup.string("Enter Address").required("Address is required"),
});

const AddDriver = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPreviewImage(file);
    }
  };

  const initialValues = {
    driver_name: "",
    driver_contact: "",
    driver_email_id: "",
    driver_address: "",
    dl_no: "",
    aadhar_no: "",
    date_of_birth: "",
    pan_no: "",
    pin_code: "",
    driver_image: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const formData = new FormData();
          formData.append("driver_name", values.driver_name);
          formData.append("driver_contact", values.driver_contact);
          formData.append("driver_email_id", values.driver_email_id);
          formData.append("driver_address", values.driver_address);
          formData.append("dl_no", values.dl_no);
          formData.append("aadhar_no", values.aadhar_no);
          formData.append("date_of_birth", values.date_of_birth);
          formData.append("pan_no", values.pan_no);
          formData.append("pin_code", values.pin_code);
          formData.append("driver_image", previewImage);
          formData.append("c_by", sessionData.data.id);
          const res = await DriverService.addDriver(formData);

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/driver");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Add Driver" items={BCrumb} />
      <ParentCard title="Add Driver Form">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Driver Registration Form
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/driver");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            {/*   ==== driver  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="driver_name">
                Driver Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="driver_name"
                name="driver_name"
                type="text"
                value={values.driver_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.driver_name && Boolean(errors.driver_name)}
                helperText={touched.driver_name && errors.driver_name}
                variant="outlined"
                placeholder="Enter driver name"
                fullWidth
              />
            </Grid>
            {/* ==== Contact no ===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="driver_contact">
                Contact No
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="driver_contact"
                name="driver_contact"
                type="text"
                value={values.driver_contact}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.driver_contact && Boolean(errors.driver_contact)}
                helperText={touched.driver_contact && errors.driver_contact}
                variant="outlined"
                placeholder="Enter Contact no"
                fullWidth
              />
            </Grid>
            {/* ==== Email Id ===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="driver_email_id">
                Email Id
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="driver_email_id"
                name="driver_email_id"
                type="email"
                value={values.driver_email_id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.driver_email_id && Boolean(errors.driver_email_id)
                }
                helperText={touched.driver_email_id && errors.driver_email_id}
                variant="outlined"
                placeholder="Enter Email Id"
                fullWidth
              />
            </Grid>

            <Grid
              item
              llg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="dl_no">
                Driving License <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="dl_no"
                name="dl_no"
                type="text"
                value={values.dl_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.dl_no && Boolean(errors.dl_no)}
                helperText={touched.dl_no && errors.dl_no}
                variant="outlined"
                placeholder="Enter Driving License No"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="aadhar_no">
                Aadhar No
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="aadhar_no"
                name="aadhar_no"
                type="text"
                value={values.aadhar_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.aadhar_no && Boolean(errors.aadhar_no)}
                helperText={touched.aadhar_no && errors.aadhar_no}
                variant="outlined"
                placeholder="Enter Aadhar No"
                fullWidth
              />
            </Grid>

            {/* <Grid item lg={6} md={12} sm={12} style={{ marginTop: "-10px" }}>
              <CustomFormLabel htmlFor="age">
                Age
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="age"
                name="age"
                type="text"
                value={values.age}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.age && Boolean(errors.age)}
                helperText={touched.age && errors.age}
                variant="outlined"
                placeholder="Enter Age"
                fullWidth
              />
            </Grid> */}

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="date_of_birth">
                Date of Birth
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="date_of_birth"
                name="date_of_birth"
                type="date"
                value={values.date_of_birth}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.date_of_birth && Boolean(errors.date_of_birth)}
                helperText={touched.date_of_birth && errors.date_of_birth}
                variant="outlined"
                placeholder="Enter Date of Birth"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="pan_no">
                Pan No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="pan_no"
                name="pan_no"
                type="text"
                value={values.pan_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.pan_no && Boolean(errors.pan_no)}
                helperText={touched.pan_no && errors.pan_no}
                variant="outlined"
                placeholder="Enter Pan No"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="pin_code">
                Pincode
                <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="pin_code"
                name="pin_code"
                type="text"
                value={values.pin_code}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.pin_code && Boolean(errors.pin_code)}
                helperText={touched.pin_code && errors.pin_code}
                variant="outlined"
                placeholder="Enter Pincode"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="driver_image">
                Upload Logo <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                accept="image/*"
                id="driver_image"
                name="driver_image"
                type="file"
                // onChange={handleFileChange}
                onChange={(event) => {
                  handleChange(event);
                  handleFileChange(event);
                }}
                onBlur={handleBlur}
                style={{ width: "100%" }}
              />
            </Grid>

            {/* ===== textarea */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="driver_address">
                Address <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <CustomTextField
                id="driver_address"
                name="driver_address"
                value={values.driver_address}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.driver_address && Boolean(errors.driver_address)}
                helperText={touched.driver_address && errors.driver_address}
                variant="outlined"
                placeholder="Enter Address"
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              {previewImage && <PreviewImage file={previewImage} />}
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddDriver;
